import { LeagueLeaderboardUser } from './league_leaderboard';
export const LEAGUE_ZONE_STATUS_PROMOTION = 'promotion';
export const LEAGUE_ZONE_STATUS_MAINTENANCE = 'maintenance';
export const LEAGUE_ZONE_STATUS_DEMOTION = 'demotion';
// 維持ゾーンから昇格ラインまでの基準は5位、降格ゾーンから降格回避ラインまでの基準は12位のスコア
const LEAGUE_PROMOTION_LINE_RANK = 5;
const LEAGUE_DEMOTION_LINE_RANK = 12;
// 昇格ゾーンと最上位ティアの維持ゾーンは同じ文言を出す（最上位は昇格枠が無く維持ゾーンに昇格ラインが存在しないため）
const TITLE_PROMOTION = '絶好調！🚀';
const SUBTITLE_PROMOTION = 'この調子でキープしよう！';
export class LeagueCompletionCard {
    constructor(data, config) {
        var _a, _b, _c;
        Object.defineProperty(this, "score", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rank", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tierIconSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "promotionZone", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "maintenanceZone", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "demotionZone", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "zoneStatus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "remainingDays", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isFirstJoin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // 今週初回（リーグ参加初回）はリーグスタート、それ以外（その日初回 or ランクアップ）はゾーン別の文言を出す
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "subTitle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.score = data.score;
        this.rank = data.rank;
        this.tierIconSrc = data.tierIconSrc ? config.cdnBaseURL + data.tierIconSrc : '';
        this.promotionZone = (((_a = data.miniLeaderboard) === null || _a === void 0 ? void 0 : _a.promotionZone) || []).map((v) => new LeagueLeaderboardUser(v, config));
        this.maintenanceZone = (((_b = data.miniLeaderboard) === null || _b === void 0 ? void 0 : _b.maintenanceZone) || []).map((v) => new LeagueLeaderboardUser(v, config));
        this.demotionZone = (((_c = data.miniLeaderboard) === null || _c === void 0 ? void 0 : _c.demotionZone) || []).map((v) => new LeagueLeaderboardUser(v, config));
        this.zoneStatus = data.zoneStatus;
        this.remainingDays = data.remainingDays;
        this.isFirstJoin = data.isFirstJoin;
        // 昇格ゾーンと最上位ティアの維持ゾーンは同じ文言を出す（最上位は昇格枠が無く維持ゾーンに昇格ラインが存在しないため）
        if (this.isFirstJoin) {
            this.title = '今週のリーグスタート！🎉';
            this.subTitle = 'レッスンするほど順位が上がるよ！';
        }
        else if (this.isPromotionZone || this.isTopTier) {
            this.title = TITLE_PROMOTION;
            this.subTitle = SUBTITLE_PROMOTION;
        }
        else if (this.isDemotionZone) {
            this.title = 'ここからだよ🔥';
            this.subTitle = `あと${this.minutesToAvoidDemotion}分レッスンすると降格回避！`;
        }
        else {
            this.title = 'その調子❤️';
            this.subTitle = `あと${this.minutesToPromotionLine}分レッスンすると昇格ライン！`;
        }
    }
    get isPromotionZone() {
        return this.zoneStatus === LEAGUE_ZONE_STATUS_PROMOTION;
    }
    get isDemotionZone() {
        return this.zoneStatus === LEAGUE_ZONE_STATUS_DEMOTION;
    }
    get isMaintenanceZone() {
        return this.zoneStatus === LEAGUE_ZONE_STATUS_MAINTENANCE;
    }
    // 最上位ティアは昇格枠が無いため promotionZone が常に空になる
    get isTopTier() {
        return this.promotionZone.length === 0;
    }
    // 昇格ライン（5位）に到達するために必要なレッスン分数
    get minutesToPromotionLine() {
        return this.minutesToRank(LEAGUE_PROMOTION_LINE_RANK);
    }
    // 降格回避ライン（12位）に到達するために必要なレッスン分数
    get minutesToAvoidDemotion() {
        return this.minutesToRank(LEAGUE_DEMOTION_LINE_RANK);
    }
    minutesToRank(rank) {
        const targetScore = this.findScoreByRank(rank);
        if (targetScore === null)
            return 0;
        // score は秒のため、到達に必要なレッスン分数へ変換する（必要分を満たすよう切り上げ）
        return Math.max(0, Math.ceil((targetScore - this.score) / 60));
    }
    findScoreByRank(rank) {
        const allUsers = [...this.promotionZone, ...this.maintenanceZone, ...this.demotionZone];
        const target = allUsers.find((user) => user.rank === rank);
        return target ? target.score : null;
    }
}
